import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';
import moment from 'moment';

const state = () => ({
  gearChangesData: null,
});

const actions = {
  async fetchGearChangesData(state, fetcher = dataFetch) {
    const res = await fetcher(API_END_POINTS.GEAR_CHANGES);
    try {
      const meetings = _meetingsSortedByDate(res.meetings);
      state.commit('SET_GEAR_CHANGES_DATA', meetings);
    } catch (err) {
      console.error(err);
    }
  },
};

/**
 * This filters out the events which is later than today or before today.
 * @param meetings
 * @returns {array}
 */
function _meetingsSortedByDate(meetings) {
  const meetingsSortedByDate = meetings.map(m => {
    return {
      meetingName: m.name,
      // only collecting events within today.
      racingEvents: m.events.filter(e => _isHappeningToday(moment(e.startsAt)) === true),
    };
  });
  // remove meeting if it doesn't have any event today
  return meetingsSortedByDate.filter(m => m.racingEvents.length > 0);
}

/**
 * To see if the passing time is within today(UTC)
 * @returns {boolean}
 */
function _isHappeningToday(eventStartTime) {
  const endingTimeOfToday = _endingTimeOfTodayUTC();
  const beginningTimeOfToday = _startTimeOfTodayUTC();
  return eventStartTime.isBefore(endingTimeOfToday) && eventStartTime.isAfter(beginningTimeOfToday);
}

/**
 * It returns a ending time of today in UTC
 * @returns {string}
 */
function _endingTimeOfTodayUTC() {
  const end = new Date();
  end.setHours(23, 59, 59, 0);
  return moment(end).toISOString();
}

/**
 * It returns a beginning time of today in UTC
 * @returns {string}
 */
function _startTimeOfTodayUTC() {
  const beginning = new Date();
  beginning.setHours(0, 0, 0, 0);
  return moment(beginning).toISOString();
}

const mutations = {
  SET_GEAR_CHANGES_DATA: (state, data) => {
    state.gearChangesData = data;
  },
};

const getters = {
  getData: state => {
    return state.gearChangesData;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
